<template>
  <div>
    <div class="flex flex-col items-center justify-center gap-8 mb-16">
      <TickCircleOutlineIcon color="#229150" :width="44" :height="44" aria-hidden="true" />
      <h1 class="font-medium text-m1">Message sent</h1>
    </div>
    <p class="text-body mb-24 text-center">Search for more sitters or continue the conversation in messages.</p>
    <Button
      v-if="isPopupMode"
      value="Continue Searching"
      variant="primary"
      size="medium"
      class="w-full mb-16"
      @click="$emit('continue-searching')"
    />
    <Button v-else value="Search for sitters" variant="primary" size="medium" class="w-full mb-16" to="/availability/search" />
    <Button value="View conversation" variant="outlined" size="medium" class="w-full" :href="`/messages?uuid=${recipientUuid}`" />
  </div>
</template>

<script lang="ts">
import TickCircleOutlineIcon from '@/graphics/icons/TickCircleOutlineIcon.vue';
import Button from '@/components/button/Button.vue';

export default {
  name: 'MessagesNewSent',
  components: { TickCircleOutlineIcon, Button },
  props: {
    recipientUuid: {
      type: String,
      required: true,
    },
    isPopupMode: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
